(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('contrasena', {
            parent: 'admin',
            url: '/admin/modificar-contrasena',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR'],
                pageTitle: 'admin.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user/contrasena/contrasena.html',
                    controller: 'ContrasenaController',
                    controllerAs: 'contrasenaCtrl'
                }
            }
        });
    }
})();
